import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cjtm",
  "use": "icon-cjtm-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"icon-cjtm\">\n<path fill-rule=\"evenodd\" fill=\"rgb(102, 102, 102)\" d=\"M13.210,13.063 L10.063,13.063 L10.063,9.916 L13.210,9.916 L13.210,13.063 ZM6.916,9.916 L6.916,6.769 L10.063,6.769 L10.063,9.916 L6.916,9.916 ZM3.769,6.769 L3.769,3.621 L6.916,3.621 L6.916,6.769 L3.769,6.769 ZM6.916,13.063 L3.769,13.063 L3.769,9.916 L6.916,9.916 L6.916,13.063 ZM0.622,9.916 L0.622,6.769 L3.769,6.769 L3.769,9.916 L0.622,9.916 ZM0.622,0.474 L3.769,0.474 L3.769,3.621 L0.622,3.621 L0.622,0.474 ZM6.916,0.474 L10.063,0.474 L10.063,3.621 L6.916,3.621 L6.916,0.474 ZM13.210,3.621 L13.210,6.769 L10.063,6.769 L10.063,3.621 L13.210,3.621 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cjtm.svg
// module id = FH1j
// module chunks = 12